/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A6Inputs */

const en_to_yaml_faq_a6 = /** @type {(inputs: To_Yaml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoting is applied only where it is needed to preserve the value. A plain word like Seoul cannot be misread, so it is written bare. A word like no could be read as a boolean by a YAML 1.1 parser, so it is quoted. The rule is minimal quoting, not no quoting.`)
};

const ko_to_yaml_faq_a6 = /** @type {(inputs: To_Yaml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용은 값을 보존하는 데 필요한 곳에만 적용됩니다. Seoul 같은 평범한 단어는 잘못 읽힐 수 없으므로 그대로 작성됩니다. no 같은 단어는 YAML 1.1 파서가 불리언으로 읽을 수 있으므로 인용됩니다. 규칙은 인용하지 않기가 아니라 최소한으로 인용하기입니다.`)
};

const ja_to_yaml_faq_a6 = /** @type {(inputs: To_Yaml_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用は値を保つのに必要な箇所だけに適用されます。Seoul のようなありふれた語は読み違えられないので裸で書かれます。no のような語は YAML 1.1 のパーサが真偽値として読みうるので引用されます。規則は引用しないことではなく、最小限に引用することです。`)
};

/**
* | output |
* | --- |
* | "Quoting is applied only where it is needed to preserve the value. A plain word like Seoul cannot be misread, so it is written bare. A word like no could be r..." |
*
* @param {To_Yaml_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a6 = /** @type {((inputs?: To_Yaml_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a6(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a6(inputs)
	return ja_to_yaml_faq_a6(inputs)
});